import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import * as Actions from './../store/actions';
import { Grid, TextField, FormControlLabel, Checkbox } from '@material-ui/core';
import ComponentTrackingInfo from '../../../components/ComponentTrackingInfo';
import { getSharedTextFieldProps } from '../../../components/helpers';
import ContentLabelForm from '../../content_label/ContentLabelForm';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    gridWrapper: {
        width: '80%'
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    customInput: {
        color: 'blue',
        cursor: 'pointer',
        textDecoration: 'underline',
        // maxWidth: '120px'
    }
});

class QuizForm extends Component {
    handleChange = (field_name) => (event) => {
        const { quiz, updateQuizBuilder } = this.props;

        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        updateQuizBuilder(update_data);
    }

    handleBlur = (field_name) => (event) => {
        const { updateQuizBuilder } = this.props;
        let new_value = event.target.value;

        if (isNaN(new_value)) {
            new_value = Number(0);
        } else {
            new_value = Math.abs(Number(new_value));

        }
        if (field_name === 'MinScore' || field_name === 'TotalScore') {
            new_value = Number(new_value).toFixed(1);
        }

        const update_data = {
            [field_name]: new_value
        }
        updateQuizBuilder(update_data);
    }

    handleCopyClick = () => {
        this.props.toggleQuizRepull(true)
        return this.props.history.push('/quiz/edit/' + this.props.copiedQuiz.quiz_id)
    }

    render() {
        const { classes, quiz, view_type } = this.props;
        return (
            <div className="px-24">
                <Grid container spacing={8}>
                    <Grid item xs={6}>
                        <Grid item xs={12}>
                            <TextField
                                id="QuizName"
                                label="Quiz Name"
                                className={classes.textField}
                                value={quiz.header.QuizName}
                                onChange={this.handleChange('QuizName')}
                                margin="normal"
                                disabled={view_type === 'detail'}
                                variant={"outlined"}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="QuizDescription"
                                label="Quiz Description"
                                className={classes.textField}
                                value={quiz.header.QuizDescription}
                                onChange={this.handleChange('QuizDescription')}
                                margin="normal"
                                disabled={view_type === 'detail'}
                                variant={"outlined"}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container className={classes.gridWrapper}>
                                <Grid item xs={6}>
                                    <TextField
                                        id="MinScore"
                                        label="Score needed to Pass"
                                        className={classes.textField}
                                        // value={Number(quiz.header.MinScore).toFixed(1)}
                                        value={quiz.header.MinScore}
                                        onChange={this.handleChange('MinScore')}
                                        margin="normal"
                                        disabled={view_type === 'detail'}
                                        variant={"outlined"}
                                        onBlur={this.handleBlur('MinScore')}
                                        type='number'
                                        inputProps={{
                                            min: 0,
                                            step: 1
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        id="TotalScore"
                                        label="Total Score"
                                        className={classes.textField}
                                        // value={Number(quiz.header.TotalScore).toFixed(1)}
                                        value={quiz.header.TotalScore}
                                        onChange={this.handleChange('TotalScore')}
                                        margin="normal"
                                        disabled={view_type === 'detail'}
                                        variant={"outlined"}
                                        onBlur={this.handleBlur('TotalScore')}
                                        type='number'
                                        inputProps={{
                                            min: 0,
                                            step: 1
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="MaxAttempt"
                                label="Max Attempt"
                                className={classes.textField}
                                value={quiz.header.MaxAttempt}
                                onChange={this.handleChange('MaxAttempt')}
                                helperText="Leave as 0 for no Attempt Limit"
                                margin="normal"
                                disabled={view_type === 'detail'}
                                variant={"outlined"}
                                onBlur={this.handleBlur('MaxAttempt')}
                                type='number'
                                inputProps={{
                                    min: 0,
                                    step: 1
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="TimeLimit"
                                label="Time Limit (in minutes)"
                                className={classes.textField}
                                value={quiz.header.TimeLimit}
                                onChange={this.handleChange('TimeLimit')}
                                margin="normal"
                                disabled={view_type === 'detail'}
                                variant={"outlined"}
                                helperText="Leave as 0 for no Time Limit"
                                onBlur={this.handleBlur('TimeLimit')}
                                type='number'
                                inputProps={{
                                    min: 0,
                                    step: 1
                                }}
                            />
                        </Grid>
                        {/* <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={(quiz.header.Active === 1 || quiz.header.Active === true)}
                                        onChange={this.handleChange('Active')}
                                        value="Active"
                                        color="primary"
                                    />
                                }
                                label="Active"
                                disabled={view_type === 'detail'}
                            />
                        </Grid> */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={(quiz.header.IsRequired === 1 || quiz.header.IsRequired === true)}
                                        onChange={this.handleChange('IsRequired')}
                                        value="Active"
                                        color="primary"
                                    />
                                }
                                label="Is Required to Pass Course"
                                disabled={view_type === 'detail'}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={(quiz.header.RandomizeQuestionOrder === 1 || quiz.header.RandomizeQuestionOrder === true)}
                                        onChange={this.handleChange('RandomizeQuestionOrder')}
                                        value="RandomizeQuestionOrder"
                                        color="primary"
                                    />
                                }
                                label="Randomize Question Order"
                                disabled={view_type === 'detail'}
                            />
                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: '20px' }}>
                            <ContentLabelForm
                                labelList={this.props.contentLabelList}
                                component_reference={'quiz'}
                                component_reference_id={quiz.header.quiz_id}
                                baseComponent={quiz}
                                updateFunction={this.props.updateQuizLabels}
                                view_type={view_type}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <ComponentTrackingInfo
                            editInfo={this.props.editInfo}
                            view_type={this.props.view_type}
                            classes={classes}
                        />
                        <TextField
                            id="Event Usage"
                            label="Event Usage"
                            value={this.props.event_usage.event_list.filter((event_info) => event_info.is_in_conflict).length > 0 ? `Save Conflicts (${this.props.event_usage.event_list.filter((event_info) => event_info.is_in_conflict).length})` : 'No Save Conflicts'}
                            {...getSharedTextFieldProps('detail', classes)}
                            hidden={this.props.view_type === 'create'}
                        />
                        {this.props.copiedQuiz && !this.props.paramHistory.active ?
                            <TextField
                                id="Copied Quiz Name"
                                label="Copied Quiz Name"
                                value={this.props.copiedQuiz.QuizName}

                                inputProps={{ className: classes.customInput, onClick: () => this.handleCopyClick() }}
                                {...getSharedTextFieldProps('detail', classes)}
                            />
                            :
                            null
                        }

                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateQuizBuilder: Actions.updateQuizBuilder,
        toggleQuizRepull: Actions.toggleQuizRepull,
        updateQuizLabels: Actions.updateQuizLabels
    }, dispatch);
}

function mapStateToProps({ paramHistory, auth, contentLabelReducer }) {
    return {
        paramHistory: paramHistory.courseBuilder,
        contentLabelList: contentLabelReducer.contentLabelReducer.contentLabelList,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizForm)));



// WEBPACK FOOTER //
// src/main/content/quiz/quizBuilder/QuizForm.js